/***********************************************************
Alexander Self
8/22/17
Gang View: View user created gangs(teams of employees)
***********************************************************/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchGangs, selectGang, deleteGang } from '../../../actions/team_actions';
import TeamList from '../view/team_list';
import EmployeeTable from '../../employee_table';

class TeamDelete extends Component {
  componentDidMount() {
    return this.props.fetchGangs();
  }
  render() {
    return (
      <div className="row">
        <blockquote><span className="flow-text">Team Delete</span></blockquote>
        <div className="col s12 m12 l3 xl3">
          <div className="emp-list">
            <div className="card">
              <TeamList gangs={this.props.gangs} onClick={this.props.selectGang} />
            </div>
          </div>
        </div>
        <div className="col s12 m12 l9 xl9">
            { this.props.selectedGang.emps.length > 0 ?
              <div className="row">
                <div className="col s12 m3 l3 xl3">Team No: <b>{ this.props.selectedGang.gangId }</b></div>
                <div className="col s12 m3 l3 xl3">Team Location: <b>{ this.props.selectedGang.gangLoc === 71 ? `${this.props.selectedGang.gangLoc} - Ka'u` : `${this.props.selectedGang.gangLoc} - Kea'au` }</b></div>
                <div className="col s12 m3 l3 xl3">Team Count: <b>{ this.props.selectedGang.gangCount }</b></div>
                <div className="col s12 m3 l3 xl3"><button onClick={() => this.props.deleteGang(this.props.selectedGang)} className="btn waves-effect waves-light red">Delete</button></div>
              </div> : ''
            }
           <hr />
          <div className="row">
            <div className="scrollable">
              { this.props.selectedGang.emps.length > 0 ? <EmployeeTable employees={this.props.selectedGang.emps} noClick={true} /> : '' }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    gangs: state.gang.gangs,
    selectedGang: state.gang.selectedGang
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchGangs,
    selectGang,
    deleteGang
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TeamDelete);











































/* END */



// WEBPACK FOOTER //
// ./src/components/teams/delete/team_delete.js